import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "./ThemeContext";
import { FaDiscord, FaPatreon, FaInstagram } from "react-icons/fa"; // at the top

export default function Home() {
	const { darkMode, setDarkMode } = useTheme();

  return (
    <div className="min-h-screen bg-white text-black dark:bg-black dark:text-white transition-all duration-300">
    <main className="px-6 py-10 font-sans">
      <header className="flex justify-between items-center border-b border-gray-300 dark:border-gray-700 pb-4 mb-10">
  <h1 className="text-3xl font-bold text-red-500">ZXL Studio</h1>
  <div className="flex items-center space-x-4 text-gray-500 dark:text-gray-300">
    <nav className="space-x-6">
      <a href="#projects" className="hover:text-white">Projects</a>
      <Link to="/services" className="hover:text-white">Services</Link>
      <a href="https://zxldev.com/blog" target="_blank" rel="noopener noreferrer">Blog</a>
	  <a href="https://zxldev.com/forums" target="_blank" rel="noopener noreferrer">Forums</a>
      <Link to="/contact" className="hover:text-white">Contact</Link>
    </nav>
    <div className="flex items-center space-x-3 ml-4 text-xl">
      <a href="https://discord.com/channels/1077475224032911370/1077475224502681665" target="_blank" rel="noopener noreferrer"><FaDiscord className="hover:text-white" /></a>
      <a href="https://www.instagram.com/zxlstudio/?igsh=aGswYndpcm81OXFx" target="_blank" rel="noopener noreferrer"><FaInstagram className="hover:text-white" /></a>
	  <a href="https://www.patreon.com/zxlstudio" target="_blank" rel="noopener noreferrer"><FaPatreon className="hover:text-white" /></a>
    </div>
    <button
      onClick={() => setDarkMode(!darkMode)}
      className="p-2 text-xl bg-transparent hover:text-white transition-colors duration-200"
      title="Toggle theme"
    >
      {darkMode ? "☀" : "🌙"}
    </button>
  </div>
</header>


      <section className="text-center mb-20">
        <h2 className="text-4xl font-semibold mb-4">
          Unchained ideas. No hate. No harm. Just games.
        </h2>
		<div className="bg-white text-black dark:bg-black dark:text-white">
		</div>
        <div className="space-x-4 mt-6">
		<a href="#projects">
		<button className="bg-red-600 text-white px-6 py-2 rounded-md hover:bg-red-500">
		Explore My Work</button>
		</a>
		<Link to="/contact"><button className="bg-gray-700 text-white px-6 py-2 rounded-md hover:bg-gray-600">
		Hire Me
		</button>
		</Link>
		</div>

      </section>

      <section className="mb-20" id="about">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <img src="/images/dev-portrait.jpg" alt="Developer" className="rounded-md mx-auto" />
          <div>
            <h3 className="text-2xl font-bold mb-2">Founder & Lead Developer of ZXL Studio</h3>
            <p className="text-gray-400">
I’m an independent game creator driven by a love for storytelling, player freedom, and provocative ideas. What began as curiosity with the RPGMaker series has grown into a mission: to build daring, stylish, and memorable games that blur the lines between fun and fantasy. With a bold blend of AI tools, handcrafted logic, and unapologetic charm, I craft experiences that entertain, tease, and surprise—one pixel at a time.

I’m also actively seeking like-minded collaborators who share this vision. While I’ve come far alone, I believe the next level comes from working together—scaling these ideas into something bigger, better, and bolder.
            </p>
          </div>
        </div>
      </section>

      <section className="mb-20" id="projects">
        <h3 className="text-3xl font-bold mb-6">Current Projects</h3>
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-gray-900 p-4 rounded-md">
            <img src="/images/forbidden-fantasy.jpg" alt="Forbidden Fantasy" className="rounded-md mb-4 mx-auto" />
            <h4 className="text-xl font-semibold mb-1">Forbidden Fantasy</h4>
            <p className="text-gray-400 text-sm mb-3">A completed fantasy RPG of adventure and intrigue.</p>
            <div className="space-x-3">
			  <a className="text-red-400 hover:underline"
				href="https://zxlstudio.itch.io/ffrpg-demo"
				target="_blank"
				rel="noopener noreferrer">
				Demo</a>
              <a className="text-red-400 hover:underline"
				href="https://www.patreon.com/collection/169190?view=expanded"
				target="_blank"
				rel="noopener noreferrer">
				Devlog
			</a>

            </div>
          </div>
		
          <div className="bg-gray-900 p-4 rounded-md">
            <img src="/images/fojd.jpg" alt="FoJD" className="rounded-md mb-4 mx-auto" />
            <h4 className="text-xl font-semibold mb-1">FoJD (Project C)</h4>
            <p className="text-gray-400 text-sm mb-3">
			Playable alpha-test version available<br /> (Paid Patreon Members only!).
			</p>

            <div className="space-x-3">
              <a className="text-red-400" href="https://zxldev.com/zxlstudio/FoJD/index.php"
				target="_blank"
				rel="noopener noreferrer">Try it out!</a>
            </div>
          </div>

          <div className="bg-gray-900 p-4 rounded-md">
            <img src="/images/toz.jpg" alt="The Other Zone" className="rounded-md mb-4 mx-auto" />
            <h4 className="text-xl font-semibold mb-1">The Other Zone</h4>
            <p className="text-gray-400 text-sm mb-3">Story-driven sci-fi mystery in early stages.</p>
            <div className="space-x-3">
			  <button disabled className="text-red-400">Preview (Coming soon!)</button>
            </div>
          </div>
        </div>
      </section>

      <section className="text-center text-gray-300" id="support">
        <p className="text-lg mb-3">Support and get the latest updates of ZXL Studio on</p>
        <a href="https://www.patreon.com/zxlstudio" className="text-white font-semibold text-xl">Patreon</a>
      </section>
    </main>
	</div>
  );
}
